import { SET_SIGN_IN_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const signInUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SIGN_IN_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default signInUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignIn/reducer.js